module.exports = {
	"articleTitle1": "Michigan impresses at Simmons-Harvey Invitational ",
	"catImage": "redstar.png",
	"totalCats": 1,
	"name": "U-M Indoor Track",
	"articleLink2": "https://www.michigandaily.com/taxonomy/term/66",
	"articleSnippet1": "Jan 17, 2017 ... The men's team dominated in five events, and the women's side took four events \ntitles in the final meet at the U-M Indoor Track Building.",
	"articleSnippet2": "Track & Field. ... Michigan takes 22nd at NCAA Indoor Championships ... \nwomen's side took four events titles in the final meet at the U-M Indoor Track \nBuilding.",
	"totalMisc": 0,
	"articleTitle2": "Track & Field ",
	"address": "1150 S State St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170326/elr.RUN_.simmonsharvey.1.14.17.433.jpg?itok=mA72pQHp",
			"author": "Emma Richter",
			"caption": "Sophomore Taylor McLaughlin put together a 51.48-second run to finish third in the 400-meter hurdles."
		},
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/170122/ara.RUN_.Invitational.1.17.15.025.jpg?itok=uYY7BJNl",
			"author": "File Photo",
			"caption": "Sophomore Joe Ellis surpassed his own program record in the weight throw twice at at the Notre Dame Invitational"
		}
	],
	"position": {
		"lat": 42.268127,
		"lng": -83.745078
	},
	"tips": [],
	"articleLink1": "#",
	"categories": {
		"misc": 1,
		"location": 1,
		"athleticfacility": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/umindoortrack.json
// module id = 994
// module chunks = 0